import Dropdown from 'react-bootstrap/Dropdown';
import { Button } from 'react-bootstrap';
import {
  ChevronLeft,
  ChevronRight,
} from 'react-bootstrap-icons';

export interface CustomFooterProps {
  pageSize: number;
  pageSizes: readonly number[];
  /** 0-based */
  currentPage: number;
  totalPages: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

/**
 * Футер custom-темы — клон пагинации CustomDataTable: слева «Показывать по:»
 * с дропдауном и «1-10 из N», справа шевроны и окно из 5 кнопок страниц.
 * Располагается ВНЕ рамки таблицы (mt-3), показывается только при наличии данных.
 */
const CustomTableFooter = ({
  pageSize,
  pageSizes,
  currentPage,
  totalPages,
  totalCount,
  onPageChange,
  onPageSizeChange,
}: CustomFooterProps) => {
  const fromRow = totalCount > 0 ? currentPage * pageSize + 1 : 0;
  const toRow = Math.min((currentPage + 1) * pageSize, totalCount);

  const pageNumbers: number[] = [];
  const buttonsCount = Math.min(5, totalPages);

  for (let i = 0;i < buttonsCount;i += 1) {
    let pageNum: number;

    if (totalPages <= 5 || currentPage < 2) {
      pageNum = i;
    } else if (currentPage > totalPages - 3) {
      pageNum = totalPages - 5 + i;
    } else {
      pageNum = currentPage - 2 + i;
    }

    pageNumbers.push(pageNum);
  }

  return (
    <div className='d-flex justify-content-between align-items-center mt-3'>
      <div className='d-flex align-items-center'>
        <span className='mr-2'>Показывать по:</span>

        <Dropdown>
          <Dropdown.Toggle variant='outline-secondary' size='sm'>
            { pageSize }
          </Dropdown.Toggle>

          <Dropdown.Menu>
            { pageSizes.map(size => (
              <Dropdown.Item
                key={ size }
                active={ size === pageSize }
                onClick={ () => onPageSizeChange(size) }
              >
                { size }
              </Dropdown.Item>
            )) }
          </Dropdown.Menu>
        </Dropdown>

        <span className='ml-3'>
          { fromRow }-{ toRow } из { totalCount }
        </span>
      </div>

      <div className='d-flex align-items-center'>
        <Button
          variant='outline-secondary'
          size='sm'
          disabled={ currentPage === 0 }
          onClick={ () => onPageChange(Math.max(0, currentPage - 1)) }
          className='mr-2'
        >
          <ChevronLeft />
        </Button>

        <div className='d-flex'>
          { pageNumbers.map(pageNum => (
            <Button
              key={ pageNum }
              variant={ currentPage === pageNum ? 'primary' : 'outline-secondary' }
              size='sm'
              onClick={ () => onPageChange(pageNum) }
              className='mx-1'
              style={ { minWidth: '40px' } }
            >
              { pageNum + 1 }
            </Button>
          )) }
        </div>

        <Button
          variant='outline-secondary'
          size='sm'
          disabled={ currentPage >= totalPages - 1 }
          onClick={ () => onPageChange(Math.min(totalPages - 1, currentPage + 1)) }
          className='ml-2'
        >
          <ChevronRight />
        </Button>
      </div>
    </div>
  );
};

export default CustomTableFooter;
